/**
 * User selector.
 *
 * @param {object} state Store state.
 * @returns {Immutable.Map} User data.
 */
export const userSelector = state => state.auth.get('user');
